"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionChartSettingsComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const RetentionHighchartsSettingsChartTypeComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/highchartsSettings/RetentionHighchartsSettingsChartTypeComponent");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const RetentionHighchartsSettingsRetentionTableComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionHighchartsSettingsRetentionTableComponent");
const RetentionHighchartsSettingsFilterOvertimePeriodComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/highchartsSettings/RetentionHighchartsSettingsFilterOvertimePeriodComponent");
const RetentionHighchartsSettingsFilterCohortDaysComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/highchartsSettings/RetentionHighchartsSettingsFilterCohortDaysComponent");
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const RetentionChartSettingsComponent = () => {
    var _a;
    const retentionPageDataContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const highchartsOptionsContext = (0, HighchartsOptionsProvider_1.useHighchartsOptionsContext)();
    const { inProgress, loaded } = retentionPageDataContext.state.status;
    const { isError } = retentionPageDataContext.state.error;
    const chartType = retentionPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel().getChartType();
    const isOvertime = chartType === RetentionChartSettingsJSONModel_1.ChartType.overtime;
    const chartHasNoData = ((_a = highchartsOptionsContext.state.chartStatus) === null || _a === void 0 ? void 0 : _a.status) === "noData";
    const disabled = inProgress || isError || !loaded ||
        lodash_1.default.isNil(retentionPageDataContext.state.data) ||
        chartHasNoData;
    return React.createElement(antd_1.Row, { justify: "end", align: "middle", className: "highchartsSettingsRow" },
        React.createElement(antd_1.Col, null,
            React.createElement(antd_1.Space, { className: "highchartsOptionsComponent" },
                React.createElement(RetentionHighchartsSettingsChartTypeComponent_1.RetentionHighchartsSettingsChartTypeComponent, null),
                !isOvertime && React.createElement(RetentionHighchartsSettingsFilterCohortDaysComponent_1.RetentionHighchartsSettingsFilterCohortDaysComponent, null),
                isOvertime && React.createElement(RetentionHighchartsSettingsFilterOvertimePeriodComponent_1.RetentionHighchartsSettingsFilterOvertimePeriodComponent, null),
                React.createElement(RetentionHighchartsSettingsRetentionTableComponent_1.RetentionHighchartsSettingsRetentionTableComponent, { disabled: disabled }))));
};
exports.RetentionChartSettingsComponent = RetentionChartSettingsComponent;
